import React from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import moment from 'moment';
import {isEmpty, get} from "lodash"
import {getSymbolFromCurrency} from "currency-symbol-map";
import Button from '@material-ui/core/Button';

import {fetchMyInvoices, getPdfInvoiceByFileName, getPdfContratByFileName,	getInvoiceList, getPdfInvoiceByID} from "../../actions/InvoiceActions";
import {fetchCalendarInfo} from "../../actions/BillingAccountActions";
import chargeInstanceService from "../../services/ChargeInstanceService";
@connect ((store) =>{
	return {
		myInvoices: store.invoice.myInvoices,
		messages:store.messages.messages,
		calendar: store.billingAccount.calendar,
		providerCFs: store.provider.customFields,
		subscription: store.subscription.subscription
	}
})
export default class MyInvoicesDetails extends React.Component {
	constructor() {
		super();
	};

	componentDidMount() {};

	downloadPdfInvoice = (invoice) => () => {
		this.props.dispatch(getPdfInvoiceByID(invoice.id));
	};

	downloadPdf = (name, path) => () => {
		this.props.dispatch(getPdfContratByFileName(name, path));
	};

	render() {
		const { myInvoices, calendar, subscription, providerCFs, messages } = this.props;
		const { calendarType, days } = calendar || "";
		const invoicesFiltered = !!myInvoices && myInvoices.filter(invoice => !!invoice.invoiceNumber)
		const hasInvoice = !!invoicesFiltered && invoicesFiltered.length > 0;
		const {userAccount = {}, seller= {}} = subscription || {};
		const {billingAccount= {}} = userAccount  || {}
		const {customerAccount= {}} = billingAccount || {}
		let displayNextInvoice ="" ;
		const currentDate = moment(Date.now()).format("YYYY/MM/DD");
		const date = new Date(currentDate);
		const { services, offerTemplate={} } = subscription || {};
		const serviceTry = !!services && services.find(service => service.code === serviceInstanceTry);
		const endAgreementDateofTry = !!serviceTry && new Date(serviceTry.endAgreementDate);
		const {totalInvoiceBalance, dateDunningLevel } = customerAccount ||{};
		let balance = 0;
		if (totalInvoiceBalance > 0) balance = `-${totalInvoiceBalance}`;
		else if (totalInvoiceBalance < 0) balance = `${Math.abs(totalInvoiceBalance)}`;
		const {customField} = providerCFs || {};
		const {customFields = []} = subscription || {};
		const retryPayment = (customFields || []).find(cf => cf.code ==="CF_RETRY_PAYMENT");
		const repayment = (customField || []).find(CF=> CF.code === "CF_PROV_FD_REPAYMENT_DURATION") || {};
		const repayTime = dateDunningLevel + repayment.longValue * 86400000;
		const repayDate =repayTime && moment(repayTime).format("DD/MM/YYYY") || "";
		const symbol = !!customerAccount && getSymbolFromCurrency(customerAccount.currency);
		const latestDue = !!invoicesFiltered && Math.max.apply(Math, invoicesFiltered.map(invoice => invoice.invoiceDate));
		const lastInvoice = !!invoicesFiltered && invoicesFiltered.find(invoice => invoice.invoiceDate === latestDue) || {};
		const billingCycleCF = !isEmpty(customFields) && customFields.find(cf => cf.code === CF_BILLING_CYCLE)
		const amountOffer = !isEmpty(customFields) && customFields.find(cf => {
			const {stringValue} = billingCycleCF ||""
			if(stringValue=== "MENSUEL" && cf.code ==="CF_PRIX_ABO_MENS"){
				return cf
			}
			if(stringValue=== "ANNUEL" && cf.code ==="CF_PRIX_ABO_ANN"){
				return cf
			}
			 
		});
		const status = !!subscription && (subscription.status === "TERMINATED" || subscription.status === "RESILIATED") ? messages["common.label.resiliated"] : messages["common.label.active"];
		const displayDueDate  = !!serviceTry && endAgreementDateofTry > date;
		let resiliationDate = !!subscription && new Date(subscription.terminationDate);
		resiliationDate = new Date(resiliationDate);
		let dateCloture = new Date(currentDate);
		if (calendarType === "YEARLY" && status === messages["common.label.resiliated"]) {
			days.find((day, index) => {
				if (day.month === month[resiliationDate.getMonth()].toUpperCase()) {
					if (resiliationDate.getDate() < day.day) {
						dateCloture.setDate(day.day)
					}
					if (resiliationDate.getDate() > day.day) {
						if (index === days.length - 1) {
							index = -1;
							dateCloture.setDate(days[index + 1].day);
							dateCloture.setMonth(dateCloture.getMonth() + 1);
						} else {
							dateCloture.setDate(days[index + 1].day);
							dateCloture.setMonth(dateCloture.getMonth() + 1);
						}
					}
				}
				if (dateCloture >= date) {
					displayNextInvoice = true
				} else {
					displayNextInvoice = false
				}
			})
		}
		return (
			<div id="MyInvoicesDetails">
				<div className="col-md-12">
					<div className="col-md-8">
							<p className="title stat-panel">{messages["common.label.my.invoices"]}</p>
					</div>
					<div className="col-md-12 no-padding">
						{displayNextInvoice ?
							<div className="col-md-4">
								<label className="sousTitle title-of-box">
									{messages["common.label.my.next.invoice"]}
								</label>
								<div className="box-amount">
									<div className="text-left" >
											{displayDueDate ? null : (
												<p>
													<span className='text-label primary-light-color'>
														{messages['common.label.next.pick']}
														{': '}
													</span>
													<span className='text-value'>
														{moment(this.dueDate).format('DD/MM/YYYY')}
													</span>
												</p>
											)}
									</div>
								</div>
							</div>
							: null
						}
						{status === messages["common.label.active"] &&
							<div className="col-md-4">
								<label className="sousTitle title-of-box">
									{messages["common.label.my.next.invoice"]}
								</label>
								<div className="box-amount">
									<div className="text-left" >
										<div class="col-md-12" >
											{displayDueDate ? null : (
												<p>
													<span className='text-label primary-light-color'>
														{messages['common.label.next.pick']}
														{': '}
													</span>
													<span className='text-value'>
														{moment(this.dueDate).format('DD/MM/YYYY')}
													</span>
												</p>
											)}
										</div>
									</div>
								</div>
							</div>
						}
						{<div className="col-md-4">
							<label className="sousTitle title-of-box">
								{messages["common.label.manage.my.invoicing"]}
							</label>
							<div className="box-amount">
								<div className="text-left">
									<Link to={mesCoordonnees_url.path}>
										<Button className="btn btn-theme-default">{messages["common.label.manage.my.payment.method"]}</Button>
									</Link>
										{/* <p className='text-marginTop' style={{ marginTop: '20px' }}>
											<span className='card-subtitle primary-light-color'>
												{messages['common.label.understind.my.billing']}
											</span>
											<i
												className='fa fa-question-circle-o'
												style={{
													color: '#e0e0e0',
													fontSize: '20px',
													paddingLeft: '15px'
												}}
											/>
										</p> */}
								</div>
							</div>
							</div>}
						{balance === 0 ?
							null
							:
							<div className="col-md-4">
								<h5 className="sousTitle small-size"> <i className="fa fa-exclamation-triangle" />{messages["common.label.unpaid"]}</h5>
								<div className="box-amount">
									<label className="text-left" >{messages["common.label.amount.all.unpaid"]}:&nbsp;&nbsp;&nbsp;&nbsp;    {balance} {symbol}
										<a className="picto-item" href="#" style ={{"marginLeft": "20px"}}><i className="fa fa-question-circle sideIconMenu" /><div class="lab">{messages["common.labl.bulle.information"]}</div></a>
									</label>
									{!!retryPayment && retryPayment.stringValue === "YES"}
									<p className="text-left" style={{ marginTop: "6px" }} > {messages["common.label.next.representation.of.collection"]}:<label>{repayDate}</label> </p>
								</div>
							</div>
					}
					</div>

					<div className="col-md-12">
						<div className="col-md-8">
							<div>
								<h5 className="sousTitle title-of-box">{messages["common.label.previous.invoices"]}</h5>
							</div>
						</div>
						<div >
							<div className="col-md-12">
								<table className="table table-hover box-container">
									<thead>
										<tr>
											<th>{messages["common.label.date"]}</th>
											<th>{messages["common.label.amount"]}</th>
											<th>{messages["common.label.info.payment"]}</th>
											<th>{messages["common.label.download"]}</th>
										</tr>
									</thead>
									<tbody>
										{hasInvoice &&
											myInvoices.map((invoice, index) => {
												if(index <= 12){
													const paymentStatus = invoice.paymentStatus === "NONE" ? "PENDING" : invoice.paymentStatus;
													return (
														<tr key={invoice.code}>
															<td>{moment(invoice.invoiceDate).format("DD/MM/YYYY")}</td>
															<td>{`${invoice.amountWithTax} €`}</td>
															<td>{paymentStatus}</td>
															<td>
																<span className='icon-btn'>
																	<i
																		class='fa fa-download'
																		aria-hidden='true'
																		onClick={this.downloadPdfInvoice(invoice)}
																	/>
																</span>
															</td>
														</tr>
													);
												} else {null}
											})
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/MyInvoicesDetails.jsx